export default {
  organisation: {
    isEnabled: false
  },
  'experience-records': {
    isEnabled: false
  }
};